<template>
    <div class="search-results" :class="{ 'search-loading': loading }">
        <loading-spinner
            class="loading-spinner search-loading-spinner"
            v-if="loading"
        />
        <no-search-result
            v-if="!loading && !searchResults.length"
        ></no-search-result>
        <p
            v-if="!loading && searchResults.length"
            class="lead text-center search-results-count"
        >
            {{
                $t("showing_results_from_to_total", {
                    from: pagination.from,
                    to: pagination.to,
                    totalRows: pagination.totalRows,
                })
            }}
        </p>
        <b-card
            no-body
            v-for="item in searchResults"
            :key="item.resource_type + '_' + item.id"
            class="search-results-item mb-3 shadow-sm cursor-pointer"
            @click="exploreItem(item)"
        >
            <div
                class="card-inner d-flex justify-content-start align-items-center"
            >
                <div class="d-none d-sm-block">
                    <b-img
                        v-if="hasPhoto(item)"
                        :src="item.resource_data.photos[0].square"
                        :alt="item.resource_data.name"
                    ></b-img>
                    <div
                        v-else
                        :class="[
                            'identicon',
                            'identicon-' + item.resource_type,
                        ]"
                    >
                        {{ item.resource_data.name[0] }}
                    </div>
                </div>
                <div class="flex-fill px-3">
                    <component
                        :is="componentName(item.resource_type)"
                        :item="item.resource_data"
                    ></component>
                </div>
            </div>
            <template v-slot:footer>
                <div class="d-flex justify-content-between">
                    <small class="text-muted">
                        {{
                            $t("last_modified_ago", {
                                timeago: moment(item.updated_at).fromNow(),
                            })
                        }}</small
                    >
                    <small class="text-muted"
                        >{{
                            $t("created_ago", {
                                timeago: moment(
                                    item.resource_data.created_at
                                ).fromNow(),
                            })
                        }}
                    </small>
                </div>
            </template>
        </b-card>
        <b-pagination
            v-if="pagination.totalRows > pagination.perPage"
            class="mt-4"
            v-model="page"
            :total-rows="pagination.totalRows"
            :per-page="pagination.perPage"
            aria-controls="my-table"
        ></b-pagination>
    </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import qs from "querystring";
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import ProductVariant from "./SearchResult/ProductVariant";
import Collection from "./SearchResult/Collection";
import BaseProduct from "./SearchResult/BaseProduct";
import NoSearchResult from "./SearchResult/NoSearchResult";
import LoadingSpinner from "../Common/LoadingSpinner";

const { mapFields } = createHelpers({
  getterType: "smartVaultSearch/getField",
  mutationType: "smartVaultSearch/updateField"
});

export default {
  name: "ProductList",
  components: {
    LoadingSpinner,
    NoSearchResult,
    Collection,
    ProductVariant,
    BaseProduct
  },
  data() {
    return {
      perPage: 3,
      currentPage: 1,
      rows: 25,
      sortBy: "updated",
      generalFilters: {
        query: "",
        client: null,
        collection: null
      },
      variantFilters: {},
      fields: [
        {
          key: "userControls",
          label: "",
          class: "column-user-controls"
        },
        {
          key: "name",
          label: this.$t("resource_name"),
          sortable: true
        },
        {
          key: "updated",
          label: this.$t("updated_on"),
          sortable: true
        },
        {
          key: "lastModifiedBy",
          label: this.$t("last_modified_by"),
          sortable: true
        }
      ]
    };
  },
  methods: {
    moment,
    ...mapActions("smartVaultSearch", ["search"]),
    componentName(type) {
      let typeMap = {
        collection: "collection",
        base_product: "base-product",
        product_variant: "Product-variant"
      };

      return typeMap[type];
    },
    hasPhoto(item) {
      return item.resource_data.photos && item.resource_data.photos.length;
    },
    exploreItem(item) {
      // prevent redirect on click on dropdown action
      if (event.target.classList.contains("dropdown-item")) return;

      switch (item.resource_type) {
        case "product_variant":
          window.location = `/smart-vault/${
            item.resource_data.base_product.id
          }/${item.id}`;
          break;
        case "collection":
          this.$store.commit("smartVaultSearch/setClientAndCollection", {
            client: item.resource_data.client.id,
            collection: item.id
          });
          break;
        default:
          window.location = `/smart-vault/${item.id}`;
      }
    }
  },
  computed: {
    ...mapState({
      filters: state => state.smartVaultSearch.filters,
      searchResults: state => state.smartVaultSearch.searchResults,
      pagination: state => state.smartVaultSearch.pagination,
      loading: state => state.smartVaultSearch.loading
    }),
    ...mapFields(["pagination.page"])
  },
  watch: {
    filters: {
      handler: _.debounce(function(val, old) {
        // When a filter is changed, we should start at the first page
        this.$store.commit("smartVaultSearch/setPage", 1);
        this.search();
      }, 500),
      deep: true
    },
    page() {
      this.search();
    }
  },
  mounted() {
    this.search();
  }
};
</script>
